<template>

    <!--links section-->
    <div id="links">

        <!--for every entry in the list-->
        <ul v-for="link in list" :key="link.name">

            <!--create a logo that leads to the link-->
            <a :href="link.link"
               target="_blank">
                <img :style="style"
                     :alt="link.name"
                     :src="link.logo"
                     class="logo">

                <!--<md-tooltip md-direction="top" md-delay="300">{{ link.name }}</md-tooltip>-->
            </a>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Link",
        data() {
            return {
                size: 100,
                zoomTime: 0.4,
                zoomSize: 1.05,
                list: [
                    {
                        name: "LinkedIn",
                        link: "https://in.sxtanna.com",
                        logo: require('../assets/linkedin.svg')
                    }, {
                        name: "GitHub",
                        link: "https://gh.sxtanna.com",
                        logo: require('../assets/github.svg')
                    }, {
                        name: "Korm",
                        link: "https://gh.sxtanna.com/korm",
                        logo: require('../assets/korm.svg')
                    },
                ]
            };
        },
        computed: {
            style() {
                return `
                width: ${this.size}px;
                height: ${this.size}px;
                --zoomSize: ${this.zoomSize};
                --zoomTime: ${this.zoomTime}s;`;
            }
        },
    }
</script>

<style scoped>
    /*.md-tooltip {
        padding-top: 0;
        padding-bottom: 0;
    }*/

    ul, a {
        display: inline-block;
        padding: 10px 30px;
    }

    div {
        padding-top: 30px;
        padding-bottom: 30px;
    }

    /*slight zoom on hover of the logos*/

    /*noinspection CssUnresolvedCustomProperty*/
    .logo {
        transition: all var(--zoomTime) cubic-bezier(.25, .8, .25, 1);
        -webkit-transition: all var(--zoomTime) cubic-bezier(.25, .8, .25, 1);
    }

    /*noinspection CssUnresolvedCustomProperty*/
    .logo:hover {
        transform: scale(var(--zoomSize), var(--zoomSize));
        -webkit-transform: scale(var(--zoomSize), var(--zoomSize));
    }
</style>

<style>
    .md-card.md-with-hover {
        cursor: default !important;
    }
</style>